<template>
    <div class="container-fluid not-found-page" v-if="!loading">
        <div class="row">
            <div class="col-md-12">
                <!-- Start of error-content -->
                <div class="error-content">
                    <div class="phone-numbers">
                        <div class="phone-row">
                            <div class="phone-number phone-char-1">1</div>
                            <div class="phone-number phone-char-2">2<span>ABC</span></div>
                            <div class="phone-number phone-char-3">3<span>DEF</span></div>
                        </div>
                        <div class="phone-row">
                            <div class="phone-number phone-char-4">4<span>GHI</span></div>
                            <div class="phone-number phone-char-5">5<span>JKL</span></div>
                            <div class="phone-number phone-char-6">6<span>MNO</span></div>
                        </div>
                        <div class="phone-row">
                            <div class="phone-number phone-char-7">7<span>PQRS</span></div>
                            <div class="phone-number phone-char-8">8<span>TUV</span></div>
                            <div class="phone-number phone-char-9">9<span>WXYZ</span></div>
                        </div>
                        <div class="phone-row">
                            <div class="phone-number phone-char-star">*</div>
                            <div class="phone-number phone-char-0">0</div>
                            <div class="phone-number phone-char-hash">#<span>SEND</span></div>
                        </div>
                    </div>
                    <div class="message-error">
                        <h1><span class="step-1">4</span><span class="step-2">0</span><span class="step-3">4</span> Error</h1>
                        <p>We are unable to find the page you are looking for.</p>
                        <router-link to="/" class="mt-4 btn btn-dark">Go to the home page</router-link>                        
                    </div>
                </div>
                <!-- End of error-content -->
            </div>
            <!-- End of col-md-12 -->
        </div>
        <!-- End of row -->
    </div>
</template>

<script>

export default {
    name: "NotFound",
  
    mounted() {
        this.loading = false;
    },
    data() {
        return {
            }
           
    }, //end of data

    methods: {
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.not-found-page{
    position: relative;
    display: flex;
    min-height: calc(100vh - 132px);
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #e0e6e7;
}
.not-found-page .row{
    position: relative;
}


.not-found-page .error-content {
    padding: 10% 5%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.phone-numbers {
    max-width: 15rem;
    min-width: 12rem;
    padding: .5em;
}

.not-found-page .error-content .message-error {
    padding: 0 0 0 3em;
}

.not-found-page .error-content .message-error h1 {
    color: #32444b;
    font-weight: 700;
    font-size: 5em;
    margin: 0;
}

.not-found-page .error-content .message-error p {
    font-size: 2em;
    font-weight: 600;
    color: #6692ac;
    font-family: 'Switch-Titillium', sans-serif!important;
    margin: 0;
    line-height: 1;
}

.phone-numbers .phone-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
}

.phone-numbers .phone-number {
    margin: .35rem;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    justify-content: space-between;
    color: #32444b;
    text-align: center;
    background: #FFF;
    font-size: 2.5em;
    font-weight: 700;
    border-radius: 0.2rem;
    line-height: 1;
    font-family: 'Switch-Titillium', sans-serif!important;
    height: 3.5rem;
    width: 3.5rem;
    overflow: hidden;
}

.phone-numbers .phone-number span {
    font-size: .7rem;
    font-weight: 400;
    width: 100%;
    display: block;
    line-height: 1.5;
    letter-spacing: 2px;
}

.phone-numbers .phone-char-star {
    font-size: 4em;
    line-height: 1;
}

.phone-numbers .phone-char-4 {
    -webkit-animation: 5s ease 0s infinite phone-number-press-four;
    -o-animation: 5s ease 0s infinite phone-number-press-four;
    animation: 5s ease 0s infinite phone-number-press-four;
}

.phone-numbers .phone-char-0 {
    -webkit-animation: 5s ease 0s infinite phone-number-press-zero;
    -o-animation: 5s ease 0s infinite phone-number-press-zero;
    animation: 5s ease 0s infinite phone-number-press-zero;
}

/*.message-error .step-1 {
    animation: 5s ease 0s infinite phone-number-progress-one;
}

.message-error .step-2 {
    animation: 5s ease 0s infinite phone-number-progress-two;
}

.message-error .step-3 {
    animation: 5s ease 0s infinite phone-number-progress-three;
}*/

@keyframes phone-number-press-four {
    0%, 20%, 50%, 60%, 100% {
        background: #FFF;
        color: #32444b;
    }

    30%, 40%, 70%, 90% {
        background: #32444b;
        color: #FFF;
    }
}

@keyframes phone-number-press-zero {
    0%, 40%, 70%, 100% {
        background: #FFF;
        color: #32444b;
    }

    50%, 60% {
        background: #32444b;
        color: #FFF;
    }
}

@keyframes phone-number-progress-one {
    0%, 20%, 90%, 100% {
        color: #32444b;
    }

    30%, 80% {
        color: #6692ac;
    }
}

@keyframes phone-number-progress-two {
    0%, 40%, 90%, 100% {
        color: #32444b;
    }

    50%, 80% {
        color: #6692ac;
    }
}

@keyframes phone-number-progress-three {
    0%, 60%, 90%, 100% {
        color: #32444b;
    }

    70%, 80% {
        color: #6692ac;
    }
}

/* Smaller screen sizes */
@media only screen and (max-width: 768px) {
    .not-found-page{
        min-height: calc(100vh - 72px);
    }
    .not-found-page .error-content {
        flex-direction: column;
        text-align: center;
    }

    .not-found-page .error-content .message-error {
        padding: 0;
    }

    .not-found-page .error-content .message-error h1{
        font-size: 3em;
        margin: 10px auto;
    }

    .not-found-page .error-content .message-error p{
        font-size: 1.3em;
        line-height: 1.2;
    }
}
</style>